import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-workflow-complete-page',
  standalone: true,
  imports: [],
  templateUrl: './workflow-complete-page.component.html',
  styleUrl: './workflow-complete-page.component.scss'
})
export class WorkflowCompletePageComponent implements OnInit{

  seconds: number = 5;
  private timeInterval: any;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,

  ){}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
  this.startCountDown();
  }
}

  startCountDown(): void{
    this.timeInterval = setInterval(() => {
      this.updateSeconds();
    }, 1000);
  }

  updateSeconds(): void {
    this.seconds--;
    if(this.seconds < 0){
      clearInterval(this.timeInterval);
      this.redirect();
    }
  }

  redirect():void {
    this.router.navigate(['/dashboardpage']);
  }
}
